import React from 'react';

export const ErrorScreen = () => (
  <div>
    Error Page
  </div>
);
